/* Afkar Plus - header: search panel + phone drawer (document delegation, BeyondADS 23 Sep 2026) */
(function () {
  'use strict';
  if (window.__afcLoaded) return;
  window.__afcLoaded = true;

  function drawer() { return document.querySelector('[data-afh-drawer]'); }
  function panel() { return document.querySelector('[data-afh-searchpanel]'); }

  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.hidden = false;
    document.documentElement.classList.add('afh-lock');
  }
  function closeAll() {
    var d = drawer(); if (d) d.hidden = true;
    var p = panel(); if (p) p.hidden = true;
    document.documentElement.classList.remove('afh-lock');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-afh-open]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-afh-close]')) { e.preventDefault(); closeAll(); return; }
    if (e.target.closest('[data-afh-search]')) {
      e.preventDefault();
      var p = panel(); if (!p) return;
      p.hidden = !p.hidden;
      if (!p.hidden) { var i = p.querySelector('input[type="search"]'); if (i) setTimeout(function () { i.focus(); }, 30); }
      return;
    }
    var p2 = panel();
    if (p2 && !p2.hidden && !e.target.closest('[data-afh-searchpanel]')) p2.hidden = true;
  });
  /* spotlight arrows: click the neighbouring dot so the section's own rotation logic runs */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-asp-step]'); if (!b) return;
    e.preventDefault();
    var item = b.closest('[data-asp-item]'); var hero = item && item.parentElement; if (!hero) return;
    var n = hero.querySelectorAll('[data-asp-item]').length;
    var cur = parseInt(item.getAttribute('data-asp-item'), 10) || 0;
    var next = (cur + parseInt(b.getAttribute('data-asp-step'), 10) + n) % n;
    var dot = item.querySelector('[data-asp-go="' + next + '"]'); if (dot) dot.click();
  });
  /* gift-box edits: every 3 s light up the next piece (row + pointer, exactly like a hover); after the last piece
     move on to the next set. Pauses while hovered, while the tab is hidden, and for 10 s after any tap. */
  var abQuiet = 0;
  function abFire(el, type) { if (el) el.dispatchEvent(new MouseEvent(type, { bubbles: true })); }
  setInterval(function () {
    if (document.hidden) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-ab]'), function (root) {
      if (root.classList.contains('is-individual')) return;
      var r = root.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
      var list = root.querySelector('[data-ab-list].is-active');
      var rows = list ? Array.prototype.filter.call(list.querySelectorAll('[data-ab-row]'), function (x) { return !x.classList.contains('is-off') && !x.classList.contains('is-removed'); }) : [];
      var step = root.__abStep || 0;
      if (step < rows.length) { abFire(rows[step], 'mouseover'); root.__abStep = step + 1; return; }
      if (rows.length) abFire(rows[rows.length - 1], 'mouseout');
      root.__abStep = 0;
      var tabs = Array.prototype.filter.call(root.querySelectorAll('[data-ab-tab]'), function (t) { return t.offsetParent !== null; });
      if (tabs.length > 1) { var cur = tabs.findIndex(function (t) { return t.classList.contains('is-active'); }); tabs[(cur + 1) % tabs.length].click(); }
    });
  }, 3000);
  /* Afkar index: the + adds that product to the bag (capture phase, so the card link does not navigate) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-afx-add]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (b.classList.contains('is-busy')) return;
    b.classList.add('is-busy');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-afx-add'), 10), quantity: 1 }], sections: 'cart-icon-bubble' }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var html = res && res.sections && res.sections['cart-icon-bubble'], el = document.getElementById('cart-icon-bubble');
        if (html && el) { var d = new DOMParser().parseFromString(html, 'text/html'); var inner = d.querySelector('.shopify-section'); el.innerHTML = inner ? inner.innerHTML : html; }
        document.dispatchEvent(new CustomEvent('afkar:cart:updated'));
        b.classList.add('is-added'); setTimeout(function () { b.classList.remove('is-added'); }, 1600);
      })
      .catch(function () {})
      .then(function () { b.classList.remove('is-busy'); });
  }, true);
  /* header: transparent over the homepage hero at the top; hides on scroll down, returns on scroll up */
  (function () {
    var sec = document.querySelector('.afh-section'); if (!sec) return;
    var root = document.documentElement, lastY = window.scrollY, ticking = false;
    function measure() { var a = sec.querySelector('.afh'); if (a) root.style.setProperty('--afh-h', a.offsetHeight + 'px'); }
    function busy() { return !!sec.querySelector('.afh-search:not([hidden])') || !!document.querySelector('.afh-drawer:not([hidden])'); }
    function update() {
      ticking = false;
      var y = Math.max(0, window.scrollY), dy = y - lastY;
      var top = sec.getBoundingClientRect().top + (sec.classList.contains('is-hidden') ? sec.offsetHeight : 0);
      sec.classList.toggle('is-solid', y > 8 || busy());
      if (busy() || y < 140) { sec.classList.remove('is-hidden'); root.classList.remove('afh-hidden'); }
      else if (dy > 6) { sec.classList.add('is-hidden'); root.classList.add('afh-hidden'); }
      else if (dy < -6) { sec.classList.remove('is-hidden'); root.classList.remove('afh-hidden'); }
      if (Math.abs(dy) > 6 || y < 140) lastY = y;
    }
    measure(); update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', measure);
    document.addEventListener('click', function () { setTimeout(update, 0); });
    window.addEventListener('load', measure);
  })();
  /* community reviews: centre quote + neighbours, arrows/sides step, auto every 7 s (pauses on hover) */
  function afqData(root) {
    if (!root.__afq) { try { root.__afq = JSON.parse(root.querySelector('[data-afq-data]').textContent); } catch (err) { root.__afq = []; } root.__afqI = 0; }
    return root.__afq;
  }
  function afqSize(root, q) {
    var n = (q || '').length, d = n <= 50 ? 56 : n <= 100 ? 44 : n <= 160 ? 36 : 30, m = n <= 50 ? 34 : n <= 100 ? 28 : n <= 160 ? 24 : 21;
    root.style.setProperty('--afq-q', d + 'px'); root.style.setProperty('--afq-qm', m + 'px');
  }
  function afqSlot(root, name, text) { var el = root.querySelector('[data-afq-slot="' + name + '"]'); if (el) el.textContent = text; return el; }
  function afqShow(root, i, instant) {
    var list = afqData(root), n = list.length; if (!n) return;
    i = ((i % n) + n) % n; root.__afqI = i;
    var cur = list[i], prev = list[(i - 1 + n) % n], next = list[(i + 1) % n];
    function paint() {
      afqSlot(root, 'q', '“' + cur.q + '”'); afqSlot(root, 'n', cur.n);
      afqSlot(root, 'prev-q', '“' + prev.q + '”'); afqSlot(root, 'prev-n', prev.n);
      afqSlot(root, 'next-q', '“' + next.q + '”'); afqSlot(root, 'next-n', next.n);
      afqSlot(root, 'i', (i + 1 < 10 ? '0' : '') + (i + 1));
      var a = root.querySelector('[data-afq-slot="link"]'); if (a && cur.u) a.setAttribute('href', cur.u + '#judgeme_product_reviews');
      afqSize(root, cur.q); root.classList.remove('is-swapping');
    }
    if (instant) { paint(); return; }
    root.classList.add('is-swapping'); setTimeout(paint, 320);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-afq-prev],[data-afq-next]'); if (!b) return;
    var root = b.closest('[data-afq]'); if (!root) return;
    afqData(root); root.__afqT = Date.now();
    afqShow(root, root.__afqI + (b.hasAttribute('data-afq-next') ? 1 : -1));
  });
  function afqInit() { Array.prototype.forEach.call(document.querySelectorAll('[data-afq]'), function (root) { afqData(root); afqSize(root, (root.__afq[0] || {}).q); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', afqInit); else afqInit();
  setInterval(function () {
    if (document.hidden) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-afq]'), function (root) {
      if (root.matches(':hover') || Date.now() - (root.__afqT || 0) < 10000) return;
      var r = root.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
      afqData(root); afqShow(root, root.__afqI + 1);
    });
  }, 7000);
  /* Shop all mega menu: hover or focus the first nav link (or the panel) to open; short delay on leave */
  (function () {
    var afh = document.querySelector('[data-afh]'); var mp = document.querySelector('[data-afh-megapanel]');
    if (!afh || !mp) return;
    var timer = 0;
    function inMega(el) { return !!(el && el.closest && (el.closest('[data-afh-mega]') || el.closest('[data-afh-megapanel]'))); }
    function open() {
      clearTimeout(timer);
      if (window.matchMedia('(max-width: 989px)').matches) return;
      var sec = afh.closest('.afh-section');
      document.documentElement.style.setProperty('--afh-mega-top', Math.round(afh.getBoundingClientRect().bottom) + 'px');
      afh.classList.add('is-mega'); if (sec) sec.classList.add('is-mega-open');
      var l = afh.querySelector('[data-afh-mega]'); if (l) l.setAttribute('aria-expanded', 'true');
    }
    function close(now) {
      clearTimeout(timer);
      var go = function () {
        afh.classList.remove('is-mega'); var sec = afh.closest('.afh-section'); if (sec) sec.classList.remove('is-mega-open');
        var l = afh.querySelector('[data-afh-mega]'); if (l) l.setAttribute('aria-expanded', 'false');
      };
      if (now) go(); else timer = setTimeout(go, 160);
    }
    document.addEventListener('mouseover', function (e) {
      if (inMega(e.target)) { open(); var c = e.target.closest && e.target.closest('.afh-mega__cat'); if (c && !c.classList.contains('is-on')) { Array.prototype.forEach.call(mp.querySelectorAll('.afh-mega__cat.is-on'), function (x) { x.classList.remove('is-on'); }); c.classList.add('is-on'); } }
    });
    document.addEventListener('mouseout', function (e) { if (inMega(e.target) && !inMega(e.relatedTarget)) close(); });
    document.addEventListener('focusin', function (e) { if (inMega(e.target)) open(); else if (afh.classList.contains('is-mega')) close(true); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.afh-mega__start')) close(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(true); });
    window.addEventListener('scroll', function () { if (afh.classList.contains('is-mega')) close(true); }, { passive: true });
  })();
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();
